import { useFormikContext } from "formik"
import React from "react"
import { useRouteLoaderData } from "react-router-dom"
import { findField, updateField } from "@app/utils/form"

export const useLocationTypeAddressObserver = (currentFieldsets) => {
	const { values, setFieldValue } = useFormikContext()
	const { office } = useRouteLoaderData("root")
	const customerId = values.kundenundeinsatzort_kunde_kunde__ID
	const addressType = values.kundenundeinsatzort_einsatzort_adressetyp
	const fieldNames = [
		"kundenundeinsatzort_einsatzort_strasseundhausnummer",
		"kundenundeinsatzort_einsatzort_plz",
		"kundenundeinsatzort_einsatzort_ort",
		"kundenundeinsatzort_einsatzort_adresszusatz",
	]
	const field_kundenundeinsatzort_einsatzort_strasseundhausnummer = findField(currentFieldsets, "kundenundeinsatzort_einsatzort_strasseundhausnummer")
	const einsatzortTyp = values["kundenundeinsatzort_einsatzort_adressetyp"]

	const res = React.useMemo(() => {
		if (addressType && field_kundenundeinsatzort_einsatzort_strasseundhausnummer) {
			const currentCustomer = office?.kundenliste?.find(
				({ KundenName, KUNDENNR }) => KUNDENNR?.toString() === customerId?.toString(),
			)
			const operationSite = currentCustomer?.EinsatzAdressen?.find(
				({ Adresse }) => Adresse === einsatzortTyp,
			)

			const field_adressetyp = findField(currentFieldsets, "kundenundeinsatzort_einsatzort_adressetyp");
			const montageLabel =  field_adressetyp?.options?.find(({value}) => value === "Einsatzwechseltätigkeit (Montage)")?.label;

			if (operationSite) {
				const newValues = operationSite.Adresse.split(", ")

				let newFieldsets = currentFieldsets
				fieldNames.forEach((fieldName, index) => {
					newFieldsets = updateField(newFieldsets, fieldName, (element) => {
						return {
							...element,
							disabled: true,
							condition: {
								...element.condition,
								conditionMatches: element.condition.conditionMatches + "|[0-9]+",
							},
						}
					})
					setFieldValue(fieldName, newValues[index])
				})
				if (values["kundenundeinsatzort_einsatzort_arbeitsbereich"] === montageLabel) {
					setFieldValue("kundenundeinsatzort_einsatzort_arbeitsbereich", "");
				}
				if (values["kundenundeinsatzort_einsatzort_bezeichnungdesplatzes"] === montageLabel) {
					setFieldValue("kundenundeinsatzort_einsatzort_bezeichnungdesplatzes", "");
				}
				return {
					fieldsets: newFieldsets
				}
			} else if (einsatzortTyp === "Einsatzwechseltätigkeit (Montage)") {
				const newValues = currentCustomer?.KundenAdresse
					? currentCustomer?.KundenAdresse?.split(", ")
					: [];

				let newFieldsets = currentFieldsets
				fieldNames.forEach((fieldName, index) => {
					newFieldsets = updateField(newFieldsets, fieldName, (element) => {
						return {
							...element,
							disabled: true,
						}
					})
					setFieldValue(fieldName, newValues[index])
				})
				setFieldValue("kundenundeinsatzort_einsatzort_arbeitsbereich", montageLabel);
				setFieldValue("kundenundeinsatzort_einsatzort_bezeichnungdesplatzes", montageLabel);

				// setCurrentFieldsets(newFieldsets);
				return {
					fieldsets: newFieldsets
				}
			} else {
				let newFieldsets = currentFieldsets
				fieldNames.forEach((fieldName) => {
					newFieldsets = updateField(newFieldsets, fieldName, (element) => {
						return {
							...element,
							disabled: false,
							condition: {
								...element.condition,
								conditionMatches: element.condition.conditionMatches + "|[0-9]+",
							},
						}
					})
					if (einsatzortTyp === "Siehe Anschrift") {
						setFieldValue(fieldName, "")
					}
				})
				if (values["kundenundeinsatzort_einsatzort_arbeitsbereich"] === montageLabel) {
					setFieldValue("kundenundeinsatzort_einsatzort_arbeitsbereich", "");
				}
				if (values["kundenundeinsatzort_einsatzort_bezeichnungdesplatzes"] === montageLabel) {
					setFieldValue("kundenundeinsatzort_einsatzort_bezeichnungdesplatzes", "");
				}
				// setCurrentFieldsets(newFieldsets);
				return {
					fieldsets: newFieldsets
				}
			}
		}

		// setFieldValue("kundenundeinsatzort_einsatzort_arbeitsbereich", "");
		// setFieldValue("kundenundeinsatzort_einsatzort_bezeichnungdesplatzes", "");

		return {
			fieldsets: currentFieldsets
		}
	}, [addressType, field_kundenundeinsatzort_einsatzort_strasseundhausnummer?.name, customerId, einsatzortTyp])
	return res
}

const LocationTypeAddressObserver = ({ currentFieldsets, setCurrentFieldsets }) => {
	const { fieldsets } = useLocationTypeAddressObserver(currentFieldsets)
	setCurrentFieldsets(fieldsets)
	return null
}

export default LocationTypeAddressObserver
